'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useBankFeedsStore } from '@repo/store/useBankFeedsStore'
import { useEffect, useState } from 'react'

export const OspreyBankAccountSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required
}: OspreyBankAccountSelectProps) => {
  const { bankFeeds, fetchOspreyBankAccounts, ospreyBankAccounts, removeOspreyBankAccountFromList } =
    useBankFeedsStore()
  const [options, setOptions] = useState(testData || ospreyBankAccounts || [])

  useEffect(() => {
    if (testData) return
    setOptions(ospreyBankAccounts || [])
  }, [testData, ospreyBankAccounts])

  useEffect(() => {
    if (testData || ospreyBankAccounts?.length) return
    fetchOspreyBankAccounts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testData, ospreyBankAccounts])

  useEffect(() => {
    if (!bankFeeds?.length) return
    bankFeeds.map((bf: any) => {
      removeOspreyBankAccountFromList({ ospreyBankAccountId: bf.ospreyBankAccountId })
    })
  }, [bankFeeds, removeOspreyBankAccountFromList])

  return (
    <div data-testid="OspreyBankAccountSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Osprey bank account"
        onChange={onChange}
        labelKey="name"
        valueKey="bankAccountId"
        items={options}
        value={value}
        searchable
        idLabelKey="name"
        showIdInResults={false}
        name="ospreyBankAccounts"
        size={size}
        required={required}
        sx={{ [`& > div`]: { left: 0, width: '100%' } }}
      />
    </div>
  )
}

type OspreyBankAccountSelectProps = {
  testData?: any
  value?: any
  onChange?: (val: any) => void
  sx?: any
  size?: 'small' | 'medium'
  required?: boolean
}
